import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { FilterFacet } from './FilterFacet';
import { StyledCheckboxV2 } from '../components';

interface Facility {
  label: string;
}

interface FacilitiesFacetProps {
  title: string;
  facilities: Facility[];
  selectedFacilities: string[];
  facilityCounts: Record<string, number>;
  onFacilityToggle: (facility: string) => void;
  checkboxOverrides?: Record<string, unknown>;
}

export const FacilitiesFacet: React.FC<FacilitiesFacetProps> = ({ title, facilities, selectedFacilities, facilityCounts, onFacilityToggle, checkboxOverrides }) => {
  return (
    <FilterFacet title={title}>
      <Flex
        flexDirection="column"
        gap={5}
      >
        {facilities.map(facility => (
          <StyledCheckboxV2
            key={facility.label}
            isChecked={selectedFacilities?.includes(facility.label) || false}
            onChange={() => onFacilityToggle(facility.label)}
            id={`facility-${facility.label}`}
            isDisabled={!facilityCounts[facility.label]}
            overrides={checkboxOverrides}
          >
            <Flex
              alignItems="center"
              gap={2}
            >
              <TextV2
                typographyVariant="body1"
                color="mono14"
              >
                {facility.label}
              </TextV2>
              <TextV2
                typographyVariant="body1"
                color="mono10"
              >
                ({facilityCounts[facility.label]})
              </TextV2>
            </Flex>
          </StyledCheckboxV2>
        ))}
      </Flex>
    </FilterFacet>
  );
};
